export default function a09_SearchByTerm (data) {
    console.log('SEARCH_BY_TERM', data)
    return {
      type: 'SEARCH_BY_TERM',
      payload: data
    };
  };